export class AppPhotoUpload extends HTMLElement {
  static get observedAttributes() {
    return ["label", "multiple", "disabled", "helper", "error"];
  }

  connectedCallback() {
    this.render();
  }

  attributeChangedCallback() {
    this.render();
  }

  private render() {
    const label = this.getAttribute("label") || "Registro Fotográfico Técnico";
    const multiple = this.hasAttribute("multiple");
    const disabled = this.hasAttribute("disabled");
    const helper = this.getAttribute("helper") || "Selecione ou capture fotografias técnicas (JPG, PNG, WEBP)";
    const error = this.getAttribute("error") || "";

    const id = `photo-upload-${Math.random().toString(36).substring(2, 9)}`;

    this.innerHTML = `
      <div class="form-group">
        <span class="form-label">${label}</span>
        <label for="${id}" style="display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 20px 16px; border: 1px dashed var(--color-border-default); border-radius: var(--radius-sm); background-color: var(--color-surface-secondary); cursor: ${disabled ? "not-allowed" : "pointer"}; text-align: center;">
          <input
            id="${id}"
            type="file"
            accept="image/*"
            ${multiple ? "multiple" : ""}
            ${disabled ? "disabled" : ""}
            style="display: none;"
          />
          <span style="font-size: 1.5rem; margin-bottom: 6px;">📷</span>
          <span style="font-size: 0.8125rem; font-weight: 500; color: var(--color-text-primary);">${helper}</span>
        </label>
        ${error ? `<span class="form-error">${error}</span>` : ""}
      </div>
    `;
  }
}

if (!customElements.get("app-photo-upload")) {
  if (!customElements.get("app-photo-upload")) {
    customElements.define("app-photo-upload", AppPhotoUpload);
  }
}

export class AppPhotoPreview extends HTMLElement {
  static get observedAttributes() {
    return ["src", "alt", "caption", "removable"];
  }

  connectedCallback() {
    this.render();
  }

  attributeChangedCallback() {
    this.render();
  }

  private render() {
    const src = this.getAttribute("src") || "";
    const alt = this.getAttribute("alt") || "Fotografia técnica";
    const caption = this.getAttribute("caption") || "";
    const removable = this.hasAttribute("removable");

    this.innerHTML = `
      <div style="display: flex; flex-direction: column; gap: 4px; width: 140px; border: 1px solid var(--color-border-default); border-radius: var(--radius-sm); padding: 4px; background: var(--color-surface-primary); position: relative;">
        <img src="${src}" alt="${alt}" style="width: 100%; height: 90px; object-fit: cover; border-radius: var(--radius-sm);" />
        ${caption ? `<span style="font-size: 0.6875rem; color: var(--color-text-secondary); white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">${caption}</span>` : ""}
        ${removable ? '<button type="button" style="position: absolute; top: 6px; right: 6px; background: rgba(0,0,0,0.6); color: var(--color-text-primary); border: none; border-radius: 50%; width: 20px; height: 20px; cursor: pointer; font-size: 10px; display: flex; align-items: center; justify-content: center;">✕</button>' : ""}
      </div>
    `;
  }
}

if (!customElements.get("app-photo-preview")) {
  if (!customElements.get("app-photo-preview")) {
    customElements.define("app-photo-preview", AppPhotoPreview);
  }
}

